import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationPostureGlenohumeralJoint extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Posture - Glenohemeral Joint' />
                    <label className={styles.label}>Glenohemeral Joint</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSGLENOROUND'
                        className={styles.checkbox}
                        label='Rounded'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSGLENOANTHUM'
                        className={styles.checkbox}
                        label='Anterior Humeral Head'
                    />

                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSGLENOINTROT'
                        className={styles.checkbox}
                        label='Internally Rotated'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSGLENOWNL'
                        className={styles.checkbox}
                        label='WNL'
                    />
                </div>
            </div >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSGLENOROUND ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSGLENOINTROT ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSGLENOANTHUM ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSGLENOWNL
            ? true : false
    };
}

const connectedObservationPostureGlenohumeralJoint = connect(mapStateToProps)(ObservationPostureGlenohumeralJoint);
export { connectedObservationPostureGlenohumeralJoint as ObservationPostureGlenohumeralJoint };


